import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmSubFormComponent } from './sm-sub-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmCheckboxModule } from '../sm-checkbox/sm-checkbox.module';
// import { SmDatepickerModule } from '../sm-datepicker/sm-datepicker.module';
import { SmInputModule } from '../sm-input/sm-input.module';
import { SmSelectModule } from '../sm-select/sm-select.module';
import { SmNgSelectModule } from '../sm-ng-select/sm-ng-select.module';
import { SmFileModule } from '../sm-file/sm-file.module';
import { SmDatetimepickerModule } from '../sm-datetimepicker/sm-datetimepicker.module';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SmSimpleTextareaModule } from '../sm-simple-textarea/sm-simple-textarea.module';
import { SmErrorModule } from '../sm-error/sm-error.module';


@NgModule({
  declarations: [SmSubFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SmCheckboxModule,
    SmDatetimepickerModule,
    SmInputModule,
    SmSelectModule,
    SmNgSelectModule,
    SmFileModule,
    SmSimpleTextareaModule,
    NgbModule,
    PaginationModule,
    SmErrorModule
  ],
  exports:[SmSubFormComponent]
})
export class SmSubFormModule { }
